<div
  class="demand-reasons-list"
  *ngIf="customer$ | async">
  <mat-card class="mat-elevation-z2">
    <mat-card-title> </mat-card-title>
    <mat-card-content>
      <div
        class="row"
        *ngFor="let demandReason of demandReasons$ | async; trackBy: trackById">
        <div class="col">
          <div class="demand-reason-row">
            <mat-form-field>
              <mat-label>{{
                ("title" | i18n) || "Titel" | titlecase
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="demandReason.displayName"
                [name]="'displayName-' + demandReason.id" />
            </mat-form-field>
            <mat-slide-toggle [(ngModel)]="demandReason.enableDescription">
              <span>{{
                ("enableDescription" | i18n) || "Beschreibungstext" | titlecase
              }}</span>
            </mat-slide-toggle>
            <div class="demand-reason-buttons">
              <button
                class="demand-reason-button"
                mat-button
                type="button"
                (click)="cancelChanges(demandReason.id)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="demand-reason-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="demand-reason-button save-button"
                mat-button
                type="button"
                (click)="saveDemandReason(demandReason)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="demand-reason-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
              <button
                class="demand-reason-button delete-button"
                mat-button
                type="button"
                (click)="deleteDemandReason(demandReason.id)"
                [matTooltip]="('remove' | i18n) || 'Löschen' | titlecase">
                <mat-icon
                  class="demand-reason-button-icon"
                  svgIcon="delete-trash-remove"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngFor="
          let demandReason of demandReasonsInCreation$ | async;
          let i = index
        ">
        <div class="col">
          <div class="demand-reason-row">
            <mat-form-field>
              <mat-label>{{
                ("title" | i18n) || "Titel" | titlecase
              }}</mat-label>
              <input
                matInput
                required
                [(ngModel)]="demandReason.displayName"
                [name]="'newDisplayName-' + i" />
            </mat-form-field>
            <mat-slide-toggle [(ngModel)]="demandReason.enableDescription">
              <span>{{
                ("enableDescription" | i18n) || "Beschreibungstext" | titlecase
              }}</span>
            </mat-slide-toggle>
            <div class="demand-reason-buttons">
              <button
                class="demand-reason-button"
                mat-button
                type="button"
                (click)="cancelNewDemandReason(i)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="demand-reason-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="demand-reason-button save-button"
                mat-button
                type="button"
                (click)="saveNewDemandReason(i)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="demand-reason-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <button
            class="outline-pill-button icon-left"
            type="button"
            data-cy="add-demand-reason-button"
            (click)="addNewDemandReason()">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{
              ("addDemandReason" | i18n) || "Dienstgrund hinzufügen" | titlecase
            }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
